import { render } from "./FormationFbwa.vue?vue&type=template&id=1b3b89ea&scoped=true"
import script from "./FormationFbwa.vue?vue&type=script&lang=js"
export * from "./FormationFbwa.vue?vue&type=script&lang=js"

import "./FormationFbwa.vue?vue&type=style&index=0&id=1b3b89ea&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1b3b89ea"]])

export default __exports__